export const BLUR_RADIUS = 5;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
export const BACKGROUND_COLOR = "rgba(255, 255, 255, 0.45)" as const;
